export enum PasFolders {
	PC = 'pc',
	AC = 'ac',
	AU = 'au',
	LM = 'lm'
}

export type PasRcs = NileRcs | CmaRcs | PaRcs | IqRcs | PiRcs | AcPortfolioLibraryRcs | SharedRcs | MexRcs | IretireRcs | StRcs;

export enum CmaRcs {
	DETAILS = 'pa-details',
	PERFORMANCE = 'pa-performance',
	RISK = 'pa-risk'
}


export enum PaRcs {
	ESG = 'pa-esg',
	PORTFOLIO_ANALYTICS = 'pa-portfolio-analytics',
	PERFORMANCE = 'pa-performance',
	BENCHMARK_UPDATE = 'pa-benchmark-update',
	RISK = 'pa-risk',
	DETAILS = 'pa-details',
}

export enum IretireRcs {
	RISK = 'iretire-risk'
}

export enum SharedRcs {
	TAX_DETAILS = 'tax',
	SECURITY_DETAILS = 'security-details',
	SECURITY_DETAILS_COMPARE = 'security-details-compare',
	MODEL_DETAILS = 'model-details',
	MODEL_FAMILIES = 'model-families',
	WEALTH_PROJECTIONS = 'era-wealth-projections'
}

export enum IqRcs {
	DETAILS = 'iq-details',
	FUND_ANALYTICS = 'iq-fund-analytics'
}

export enum NileRcs {
	DETAILS = 'details',
	PERFORMANCE = 'performance',
	RISK = 'risk',
	CORRELATION_MATRIX = 'correlation-matrix'
}

export enum StRcs {
	DETAILS = 'st-details',
	PERFORMANCE = 'st-performance',
	RISK = 'st-risk'
}

export enum PiRcs {
	DETAILS = 'pi-details',
	PERFORMANCE = 'pi-performance',
	RISK = 'pi-risk'
}

export enum AcPortfolioLibraryRcs {
	DETAILS = 'acpl-all',
	PERFORMANCE = 'acpl-all',
	PERFORMANCE_EXCLUDE_BENCHMARK = 'acpl-performance',
	RISK = 'acpl-all',
	RULES = 'acpl-all'
}
export enum MexRcs {
	PERFORMANCE = 'me-performance',
	ESG = 'me-esg'
}
